import { FixMeLater } from "types/FixMeLaterType";
import { CLEAR_CODED_VALUES_TOKEN, CREATE_CODED_VALUE, DELETE_CODED_VALUES, GET_CODED_TYPES, GET_CODED_VALUES, UPDATE_CODED_VALUE } from "../constants/action-types";

export interface CodedValue {
    id?: string | null,
    CodeType: string,
    CodeId: string,
    CodeValue: string
}

interface CodedValueMap { [index: string]: CodedValue }

interface CodedValueState {
    codedValues: CodedValueMap,
    currentCodedValue: CodedValue | null,
    continuationToken: string | null,
    codeTypes: string[]
}

// INITIALIZE STATE
const initialState: CodedValueState = {
    codedValues: {},
    currentCodedValue: null,
    continuationToken: null,
    codeTypes: []
};

// REDUCER
export const CodedValueReducer = (state = initialState, action: { payload: FixMeLater, type: string }): CodedValueState => {
    switch (action.type) {
        case GET_CODED_VALUES: {
            let codedValuesList = action.payload.CodedValues;
            let continuationToken = action.payload.ContinuationToken;

            const codedValues: CodedValueMap = {}
            codedValuesList.forEach((codedValue: CodedValue) => {
                if (!!codedValue.id) {
                    codedValues[codedValue.id] = codedValue;
                }
            });

            return {
                ...state,
                codedValues,
                continuationToken
            };
        }

        case GET_CODED_TYPES: {
            let codeTypes: string[] = action.payload

            return {
                ...state,
                codeTypes
            }
        }
        
        case UPDATE_CODED_VALUE: {
            let codedValue: CodedValue = action.payload.newData
            let oldId: string = action.payload.oldId

            if (!codedValue.id) {
                codedValue.id = `${codedValue.CodeType}+${codedValue.CodeId}`
            }
            const codedValues: CodedValueMap = Object.assign({}, state.codedValues)

            if (!!codedValue) {
                codedValues[codedValue.id] = codedValue
            }

            if (oldId != codedValue.id) {
                delete codedValues[oldId]
            }

            return {
                ...state,
                codedValues
            }
        }

        case CREATE_CODED_VALUE: {
            let codedValue: CodedValue = action.payload
            if (!codedValue.id) {
                codedValue.id = `${codedValue.CodeType}+${codedValue.CodeId}`
            }
            const codedValues: CodedValueMap = Object.assign({}, state.codedValues)

            if (!!codedValue) {
                codedValues[codedValue.id] = codedValue
            }

            return {
                ...state,
                codedValues
            }
        }

        case DELETE_CODED_VALUES: {
            const codedValueIds: string[] = action.payload

            const codedValues: CodedValueMap = Object.assign({}, state.codedValues)

            codedValueIds.forEach((codedValueId) => {
                delete codedValues[codedValueId]
            });

            return {
                ...state,
                codedValues
            }
        }

        case CLEAR_CODED_VALUES_TOKEN: {
            return {
                ...state,
                continuationToken: null
            }
        }

        default:
            return state;
    }
};
